export enum DestinationStatus {
  NEW = 'new',
  OLD = 'old',
  DELETED = 'deleted',
  MODIFIED = 'modified',
}
